/**
 * Normalizes a stored dimension into a form value. Saved quotes and orders
 * carry 0 when the shipment was rated with default dimensions, and 0 must come
 * back as empty — otherwise a requote fails validation and 0s reach the rating
 * API.
 *
 * Kept import-free to stay out of the LTL barrel import cycles.
 */
export const toDimensionValue = (value: unknown): number | null => {
  if (value === null || value === undefined || value === '') return null;
  const numeric = Number(value);
  if (isNaN(numeric) || numeric <= 0) return null;
  return numeric;
};
